import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Serviceimage from '../components/Gallery/Serviceimage'
import Contactfooter from '../components/Contactfooter'
import ServicesHero from '../components/Service/ServicesHero'
import Allprojects from '../components/Gallery/Allprojects'

const Gallerypage = () => {
    return (
        <div>
            <Navbar />
            <ServicesHero />
            <Allprojects/>
            <Serviceimage />

            <Contactfooter />



            <Footer />

        </div>
    )
}

export default Gallerypage